export const DASHBOARD_SCHEDULE_WEEKDAYS = [
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
  "sunday",
] as const

const EMAIL_PATTERN = /^[^@\s]+@[^@\s]+\.[^@\s]+$/
const TIME_PATTERN = /^(?:[01]\d|2[0-3]):[0-5]\d$/

export function parseScheduleRecipients(value: string): string[] {
  return value
    .split(/[\s,;]+/)
    .map((recipient) => recipient.trim())
    .filter(Boolean)
}

export function isValidScheduleEmail(value: string): boolean {
  return EMAIL_PATTERN.test(value)
}

export function isValidScheduleTime(value: string): boolean {
  return TIME_PATTERN.test(value)
}
